import { render, staticRenderFns } from "./comp_MobileMenuDrawer-MegaMenuCategories.vue?vue&type=template&id=3586671b&scoped=true&"
import script from "./comp_MobileMenuDrawer-MegaMenuCategories.vue?vue&type=script&lang=js&"
export * from "./comp_MobileMenuDrawer-MegaMenuCategories.vue?vue&type=script&lang=js&"
import style0 from "./comp_MobileMenuDrawer-MegaMenuCategories.vue?vue&type=style&index=0&id=3586671b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3586671b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VListItem,VListItemAction,VListItemTitle})
